import React, { useState, useEffect } from 'react';
import ProductCard from './ProductCard';
import { Link } from 'react-router-dom';
import { API_URL } from '../config';


const ProductGrid = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        fetch(`${API_URL}/api/products`)
            .then(res => res.json())
            .then(data => {
                if (Array.isArray(data)) {
                    setProducts(data);
                } else {
                    console.error("API did not return an array of products:", data);
                    setProducts([]);
                }
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, []);

    const nextSlide = () => {
        if (currentIndex < products.length - 4) {
            setCurrentIndex(prev => prev + 1);
        }
    };

    const prevSlide = () => {
        if (currentIndex > 0) {
            setCurrentIndex(prev => prev - 1);
        }
    };

    if (loading) return <div className="text-center py-12">Loading products...</div>;

    // Calculate maximum index to prevent scrolling past the end
    const maxIndex = Math.max(0, products.length - 4);
    const isNextDisabled = currentIndex >= maxIndex;
    const isPrevDisabled = currentIndex === 0;

    return (
    <section className="py-24 max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop animate-hero" id="marketplace">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
        <div>
          <h2 className="font-headline-md text-headline-md mb-2">Top-Rated <span className="text-primary">Expert Advisors</span></h2>
          <p className="text-on-surface-variant">Hand-picked EAs with proven backtest results and low drawdown.</p>
        </div>
        <div className="flex items-center space-x-4">
          <button 
            onClick={prevSlide}
            disabled={isPrevDisabled}
            className={`p-2 border rounded transition-all ${isPrevDisabled ? 'border-white/5 text-white/20 cursor-not-allowed' : 'border-white/10 hover:border-primary text-white'}`}
          >
            <span className="material-symbols-outlined">chevron_left</span>
          </button>
          <button 
            onClick={nextSlide}
            disabled={isNextDisabled}
            className={`p-2 border rounded transition-all ${isNextDisabled ? 'border-white/5 text-white/20 cursor-not-allowed' : 'border-white/10 hover:border-primary text-white'}`}
          >
            <span className="material-symbols-outlined">chevron_right</span>
          </button>
        </div>
      </div>
      
      <div className="overflow-hidden w-full">
        <div 
          className="flex gap-6 transition-transform duration-500 ease-in-out"
          style={{ transform: `translateX(calc(-${currentIndex} * (25% - 18px + 24px)))` }}
        >
          {products.map(product => (
            <div key={product.id} className="w-full sm:w-[calc(50%-12px)] lg:w-[calc(25%-18px)] flex-shrink-0">
              <ProductCard product={product} />
            </div>
          ))}
        </div>
      </div>
      
      <div className="mt-16 text-center">
        <Link to="/marketplace" className="inline-flex items-center justify-center space-x-2 bg-primary/10 text-primary border border-primary/20 hover:bg-primary hover:text-on-primary font-bold px-10 py-4 rounded-xl transition-all btn-shimmer group">
          <span className="font-label-md text-label-md">View All Expert Advisors</span>
          <span className="material-symbols-outlined group-hover:translate-x-1 transition-transform">arrow_forward</span>
        </Link>
      </div>
    </section>
  );
};

export default ProductGrid;
